import * as types from '../../constants';

export function changeWidth(width) {
    return {
        type: types.CHANGE_WIDTH,
        width,
    };
}